import {Money} from '@dms/api/shared';

import {roundToCents} from './roundToCents';

/**
 * Turns a down-payment percentage of the list price into an amount. The currency comes from the
 * same list price the amount is derived from, so the produced Money can never pair a percentage of
 * the list price with a currency of some other value (for example a previously entered down
 * payment).
 */
export function createLeasingDownPaymentFromPercentage(params: {
  listPrice: Money | null;
  fallbackCurrency: string;
  percentage: number;
}) {
  const amount = Number(params.listPrice?.amount ?? 0) * (params.percentage / 100);
  const roundedAmount = roundToCents(amount);

  return {
    amount: roundedAmount.toString(),
    currency: params.listPrice?.currency ?? params.fallbackCurrency,
  };
}
